
import React, { useState, useEffect } from "react";
import { Row, Col, CardBody, Card, Container, Input, Label, Form } from "reactstrap";
import "../../src/assets/css/style.css";
import SweetAlert from 'react-bootstrap-sweetalert';
import tmdbApi from "../api/tmdbApi";
import { Link, useNavigate } from "react-router-dom";
import { getSuggestedQuery } from "@testing-library/react";
import axios from 'axios';
import * as Config from "../constants/Config";
import SessionPopup from "../pages/SessionPopup";

let { lambda, appname } = window.app;


const CreatePassword = () => {



  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
  let id = params.id;



  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [passwordError, setPasswordErr] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [number, setNumber] = useState(false);
  const [upper, setUpper] = useState(false);
  const [limit, setLimit] = useState(false);
  const [lower, setLower] = useState(false);
  const [special, setSpecial] = useState(false);
  const [success, setSuccess] = useState(false);
  const [BtnLoader, setBtnLoader] = useState(false);
  const [error, setError] = useState('');
  const [image, setImg] = useState('');
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);
  const [visibility, setVisibility] = useState({ newpwd: false, cnfrmpwd: false });
  const [passwordInput, setPasswordInput] = useState({
    password: '',
    confirmPassword: ''
  })

  useEffect(() => {
    getuser();
  }, []);

  useEffect(() => {

    if (window.site === undefined) {
      setTimeout(() => {
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
          setImg(window.site.common.imageCloudfront)
        }
      }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imageCloudfront) {
      setImg(window.site.common.imageCloudfront)
    }


  }, [window.site]);

  const getuser = (e) => {
    axios({
      method: 'GET',
      url: lambda + '/userInfo?appname=' + appname + '&userid=' + id,
    })
      .then(function (response) {

        if (response?.data?.result === "Invalid token or Expired") {
          setShowSessionPopupup(true)
        } else {
          console.log("response", response?.data?.result?.[0]?.emailid);
          setEmail(response?.data?.result?.[0]?.emailid)
        }

      });
  }


  const checkInput = (e) => {
    const onlyDigits = e.target.value.replace(/\D/g, "");
    setNumber(onlyDigits);

  };

  const handlePasswordChange = (evnt) => {
    const passwordInputValue = evnt.target.value.trim();
    const passwordInputFieldName = evnt.target.name;
    const NewPasswordInput = { ...passwordInput, [passwordInputFieldName]: passwordInputValue }
    setPasswordInput(NewPasswordInput);

  }
  const handleAddclass = (evnt) => {
    var element = document.getElementById("instruction");
    element.classList.add("ins-dsp-none");
  }
  const handleRemoveclass = (evnt) => {
    var element = document.getElementById("instruction");
    element.classList.remove("ins-dsp-none");
  }

  const handleValidation = (evnt) => {
    const passwordInputValue = evnt.target.value.trim();
    const passwordInputFieldName = evnt.target.name;
    setConfirmPasswordError("")
    //for password 
    if (passwordInputFieldName === 'password') {
      const uppercaseRegExp = /(?=.*?[A-Z])/;
      const lowercaseRegExp = /(?=.*?[a-z])/;
      const digitsRegExp = /(?=.*?[0-9])/;
      const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
      const minLengthRegExp = /.{8,}/;
      const passwordLength = passwordInputValue.length;
      const uppercasePassword = uppercaseRegExp.test(passwordInputValue);
      const lowercasePassword = lowercaseRegExp.test(passwordInputValue);
      const digitsPassword = digitsRegExp.test(passwordInputValue);
      const specialCharPassword = specialCharRegExp.test(passwordInputValue);
      const minLengthPassword = minLengthRegExp.test(passwordInputValue);
      let errMsg = "";
      if (passwordLength === 0) {
        errMsg = "Password is empty";
      }
      // else if (!uppercasePassword) {
      //   errMsg = "At least one Uppercase";
      // } else if (!lowercasePassword) {
      //   errMsg = "At least one Lowercase";
      // } else if (!digitsPassword) {
      //   errMsg = "At least one digit";
      // } else if (!specialCharPassword) {
      //   errMsg = "At least one Special Characters";
      // } else if (!minLengthPassword) {
      //   errMsg = "At least minumum 8 characters";
      // } else {
      //   errMsg = "";
      // }
      if (uppercasePassword) {
        var element = document.getElementById("err1");
        element.classList.add("vaild");
        setUpper(true);
      } else {
        var element = document.getElementById("err1");
        element.classList.remove("vaild");
        setUpper(false);
      }
      if (lowercasePassword) {
        var element = document.getElementById("err");
        element.classList.add("vaild");
        setLower(true);
      } else {
        var element = document.getElementById("err");
        element.classList.remove("vaild");
        setLower(false);
      }
      if (digitsPassword) {
        var element = document.getElementById("err2");
        element.classList.add("vaild");
        setNumber(true);
      } else {
        var element = document.getElementById("err2");
        element.classList.remove("vaild");
        setNumber(false);
      }
      if (specialCharPassword) {
        var element = document.getElementById("err3");
        element.classList.add("vaild");
        setSpecial(true)
      } else {
        var element = document.getElementById("err3");
        element.classList.remove("vaild");
        setSpecial(false)
      }
      if (minLengthPassword) {
        var element = document.getElementById("err4");
        element.classList.add("vaild");
        setLimit(true)
      } else {
        var element = document.getElementById("err4");
        element.classList.remove("vaild");
        setLimit(false)
      }
      if (limit && upper && special && lower && number && confirmPasswordError === "") {
        setError("")
      }

      setPasswordErr(errMsg);
    }
    // for confirm password

  }
  const togglePassword = (e) => {
    setPasswordShown(!passwordShown);
  };
  const handleCreate = (e) => {

    if (passwordInput?.password === "") {
      setError("Please enter password");
      setTimeout(function () { setError("") }, 3000);

    } else if (passwordInput?.confirmPassword === "") {
      setError("Please enter confirm password");
      setTimeout(function () { setError("") }, 3000);

    } else if (passwordInput?.confirmPassword && (passwordInput?.confirmPassword !== passwordInput?.password)) {
      setConfirmPasswordError("Confirm password is not matched");
    }

    else if (!limit || !upper || !special || !lower || !number) {

      setError("Please enter the password as per the instructions");
      // setTimeout(function () { setError("") }, 3000);

    }

    else if (limit && upper && special && lower && number && confirmPasswordError === "") {
      setError("")
      if (passwordInput?.password === passwordInput?.confirmPassword) {
        setConfirmPasswordError("")
        createpwd();
      }
    }
    // else {
    //   createpwd();
    // }

  }
  const handleClose = () => {
    navigate("/")
  }
  const createpwd = async () => {
    setBtnLoader(true)
    try {
      const response = await tmdbApi.CreatePassword({
        "emailid": email,
        "password": passwordInput?.password
      });
      console.log(response);
      if (response?.statusCode === 200) {
        setSuccess(true);
        setBtnLoader(false)
      }
      setBtnLoader(false)
    } catch {
      setBtnLoader(false)
      console.log("error");
    }
  };
  function onConfirm() {
    navigate("/");
  };

  function handleBack() {
    navigate("/");
  };


  console.log(email)
  return (
    <>
      {showSessionPopupup && <SessionPopup />}

      <div className="signin-wrapper">
        <div className="logo_section">
          <img src={`${image}${appname}/images/web/logo-dark.png`} className="logo" id="logo-image" />
          <button className="close-btn" id="close-btn" onClick={handleClose}><span className="material-icons" id="close-icon">close</span></button>
        </div>
        <div className="signin-body">
          <div className="signin-graphic">
            <img src={`${image}${appname}/images/web/Recover-Password-Graphic.svg`} id="signin-graphic-image" />
            <h3 id="onboarding-heading">Seamless Onboarding</h3>
            <p id="onboarding-description">Successful Beginnings: Your Journey Starts Here!</p>
          </div>
          <div className="signin-section emaillogin create-psswrd" id="recover-password-section">
            <h1 className="bold-heading" id="recover-password-heading">Create Password</h1>
            <p id="recover-password-description">Get your admin account now</p>

           
            <div className="input_group_wrapper">
    <label className="form_label">Email</label>
    <div className="input_group">
        <div className="icon_wrapper">
        <span class="material-symbols-outlined">mail</span>
        </div>
        <input type="text" value={email} placeholder={email} disabled className="form-control" id="email-input" />
    </div>
</div>

            {/* <label className="form_label" htmlFor="inlineFormInputGroupNewPassword" id="new-password-label">New Password</label>
            <div className="input-group mb-3 mr-sm-2" id="new-password-input-group">
              <div className="input-group-prepend">
                <div className="input-group-text"><span className="material-symbols-outlined">lock</span></div>
              </div>
              <input type={visibility?.newpwd ? "text" : "password"} value={passwordInput?.password} onChange={(e) => handlePasswordChange(e)} onKeyUp={handleValidation} onBlur={(e) => { handleAddclass(e) }} onFocus={(e) => { handleRemoveclass(e) }} name="password" className="form-control" id="new-password-input" placeholder="New Password" />
              <div className="input-group-text" onClick={() => setVisibility((prev) => ({ ...prev, newpwd: !prev.newpwd }))} id="toggle-password-visibility">
                <span className="material-symbols-outlined">{visibility.newpwd ? "visibility_off" : "visibility"}</span>
              </div>
            </div> */}
         
 <div className="input_group_wrapper mt-3">
    <label className="form_label">New Password</label>
    <div className="input_group">
        <div className="icon_wrapper">
        <span class="material-symbols-outlined">lock</span>
        </div>
        <input type={visibility?.newpwd ? "text" : "password"} value={passwordInput?.password} onChange={(e) => handlePasswordChange(e)} onKeyUp={handleValidation} onBlur={(e) => { handleAddclass(e) }} onFocus={(e) => { handleRemoveclass(e) }} name="password" className="form-control padding-right" id="new-password-input" placeholder="New Password" />


        <span className="material-symbols-outlined lock-style" onClick={() => setVisibility((prev) => ({ ...prev, newpwd: !prev.newpwd }))}>{visibility.newpwd ? "visibility_off" : "visibility"}</span>
        </div>
        <span className="text-danger" id="password-error" style={{ position: 'absolute', top: '289px' }}>{passwordError}</span>
</div>

          {/* <span className="material-symbols-outlined visibility" id="toggle-password-visibility" onClick={() => setVisibility((prev) => ({...prev, newpwd: !prev.newpwd }))}>
              {visibility.newpwd ? "visibility_off" : "visibility"}
            </span> */}
       

          
          <div className="input_group_wrapper mt-3">
    <label className="form_label">Confirm Password</label>
    <div className="input_group">
        <div className="icon_wrapper">
        <span class="material-symbols-outlined">lock</span>
        </div>

        <input type={visibility?.cnfrmpwd ? "text" : "password"} value={passwordInput?.confirmPassword} onChange={(e) => handlePasswordChange(e)} onKeyUp={handleValidation} onBlur={(e) => { handleAddclass(e) }} onFocus={(e) => { handleRemoveclass(e) }} name="confirmPassword" className="form-control padding-right" id="confirm-password-input" placeholder="Confirm Password" />

        <span  onClick={() => setVisibility((prev) => ({ ...prev, cnfrmpwd: !prev.cnfrmpwd }))} id="toggle-confirm-password-visibility" className="material-symbols-outlined lock-style">{visibility.cnfrmpwd ? "visibility_off" : "visibility"}</span>
        </div>
        <span className="text-danger" id="password-error" >{confirmPasswordError}</span>
      
</div>
{error ? <span className="errormsg-floating error-mssgs" style={{ fontWeight: 'bold', color: 'red' }} id="general-error">{error}</span> : ""}

          <div className="signin-footer mt-4 recover_foot" id="recover-password-footer">
            <button className="fill-btn" id="submit-btn" onClick={e => handleCreate(e)} disabled={BtnLoader}>{BtnLoader ? (<img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" id="loading-icon" />) : null}Set</button>
          </div>
        </div>

        <div className="create-password-instruction ins-dsp-none" id="instruction">
          <div className="callouts-left">
            <p className="error" id="err" data-testid="lowercase-error">{lower ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain a lower case letter</p>
            <p className="error" id="err1" data-testid="uppercase-error">{upper ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain an upper case letter</p>
            <p className="error" id="err2" data-testid="number-error">{number ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain a number</p>
            <p className="error" id="err4" data-testid="special-character-error">{special ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain a special character or a space</p>
            <p className="error" id="err3" data-testid="length-error">{limit ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain at least 8 characters</p>
          </div>
        </div>
      </div>
    </div >

      <SweetAlert show={success}
        custom
        confirmBtnText="Login"
        confirmBtnBsStyle="primary"
        title={"Password set successfully"}
        onConfirm={e => onConfirm()}
      >
      </SweetAlert>
  </>
);

};

export default CreatePassword;